// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rlgQ","tabsBox":"styles_tabsBox__1NfM7","createButton":"styles_createButton__2C8al"};